export var keyCode = {
  ALT: 18,
  BACKSPACE: 8,
  CAPS_LOCK: 20,
  CTRL: 17,
  DELETE: 46,
  DOWN: 40,
  END: 35,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  MAC_ENTER: 3,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PAUSE: 19,
  RIGHT: 39,
  SHIFT: 16,
  SPACE: 32,
  TAB: 9,
  UP: 38
};